export enum QueueColor {
    RED = "#de2700",
    YELLOW = "#f4f800",
    GREEN = "#00da21",
    ORANGE = '#ffa814',
    PRIMARY = '#336d99'
}
